module.exports = __webpack_public_path__ + "img/icon-cancel.00a214f8.svg";